import React from "react";

const Title = ({ children }) => {
  return <span className="font-semibold text-lg text-primary">{children}</span>;
};

export default Title;
